// extracted by mini-css-extract-plugin
export default {"form":"MPXlp0d7","mobile":"mobile","row":"g1kf9K3o","field":"ts7LzBZr","footer":"r13DXdBn","errorMessage":"skEmSQ6T"};